import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-otp-error',
  templateUrl: './otp-error.component.html',
  styleUrls: ['./otp-error.component.scss']
})
export class OtpErrorComponent {
  assetsUrl = environment.assetsUrl;
  constructor(public moreInfoService: MoreInfoService) {}
  public config: Error = {
    route: `${this.assetsUrl}/images/cdt/icons/close-icon.svg`,
    image: 'close-icon',
    title: 'Has superado los intentos para validar el código.',
    content: this.moreInfoService.moreInfoData.otpErrorGenerate
      ? 'Por favor inténtalo otro día.'
      : 'Por favor inténtalo mañana.',
    redirect: {
      url: '/',
      text: 'Entendido'
    }
  };
}
